window.initForms = () => {
    const forms = document.querySelectorAll('form');
    
    if(typeof forms == 'undefined' || forms == null) {
        return;
    }

    forms.forEach(form => {
        const fileUploadFields = form.querySelectorAll('.Form__Field-field-file-upload');

        if(fileUploadFields.length == 0) {
            return;
        }

        fileUploadFields.forEach(fileUploadField => {
            // Get the file input field
            const fileInput = fileUploadField.querySelector('input[type="file"]');

            // When fuleUploadField is clicked, click the file input field
            fileUploadField.addEventListener('click', () => {
                fileInput.click();
            });

            // When a file is selected, update the fileUploadField text
            fileInput.addEventListener('change', () => {
                const fileName = fileInput.files[0].name;
                fileUploadField.querySelector('span').textContent = fileName;
            });

        });

        // On submit, check if the file upload field is required, has a file, and meets size restrictions
        form.addEventListener('submit', (e) => {
            const maxSize = 10 * 1024 * 1024; // 10MB in bytes

            fileUploadFields.forEach(fileUploadField => {
                const fileInput = fileUploadField.querySelector('input[type="file"]');
                const existingError = fileUploadField.nextElementSibling;

                // Remove any existing error messages before checking for new errors
                if (existingError && existingError.classList.contains('wpcf7-not-valid-tip')) {
                    existingError.remove();
                }

                // Check for required file upload
                if (fileInput.getAttribute('aria-required') && fileInput.files.length === 0) {
                    e.preventDefault();
                    fileUploadField.classList.add('Form__Field-field-file-upload--error');

                    const errorSpan = document.createElement('span');
                    errorSpan.classList.add('wpcf7-not-valid-tip');
                    errorSpan.setAttribute('aria-hidden', 'true');
                    errorSpan.textContent = 'Please upload a file.';
                    fileUploadField.after(errorSpan);

                // Check for file size exceeding 10MB limit
                } else if (fileInput.files[0] && fileInput.files[0].size > maxSize) {
                    e.preventDefault();
                    fileUploadField.classList.add('Form__Field-field-file-upload--error');

                    const errorSpan = document.createElement('span');
                    errorSpan.classList.add('wpcf7-not-valid-tip');
                    errorSpan.setAttribute('aria-hidden', 'true');
                    errorSpan.textContent = 'File size exceeds 10MB limit.';
                    fileUploadField.after(errorSpan);
                }
            });
        });

        // Listen for successful form submission to remove errors
        form.addEventListener('wpcf7mailsent', (event) => {
            if (event.target === form) {
                // Clear all errors for this form
                fileUploadFields.forEach(fileUploadField => {
                    fileUploadField.classList.remove('Form__Field-field-file-upload--error');
                    const errorSpan = fileUploadField.nextElementSibling;
                    if (errorSpan && errorSpan.classList.contains('wpcf7-not-valid-tip')) {
                        errorSpan.remove();
                    }
                });
            }
        });

    });

    let hiddenCompanyFormElement = document.getElementById('hidden-company-domain-field');
    let contactEmailFieldElement = document.getElementById('contact-email-field');

    if(contactEmailFieldElement!==null) {
        contactEmailFieldElement.addEventListener('keyup', (e) => {
            if(contactEmailFieldElement.value.includes("@")) {
                hiddenCompanyFormElement.value = contactEmailFieldElement.value.split('@').pop();
            }
        })
    }
}



window.onload = () => {
    window.initForms();
}